
        <a class="back-btn {{className}}" (click)="onClick()">
            <i class="dln-icon-retour"></i>
            <span class="desktop">{{desktopLabel}}</span>
            <span class="mobile">{{mobileLabel}}</span>
            <ng-content></ng-content>
        </a>
  